(function () {
    "use strict";

    // @ngInject
    function ConversationServiceCtor(ConversationsManager, PubSubService, Gon, AppConfigService,
                                     $window) {
        this.ConversationsManager = ConversationsManager;
        PubSubService.ventMyBitchUp(this);
        this.Gon = Gon;
        this.openConversationId = null;

        this.isMalkut = AppConfigService.isMalkutServer();
        this.isProduction = Gon.environment === 'production';
    }

    Services.ConversationService = Class(function () {

        return {

            constructor: ConversationServiceCtor,

            getDefaultLiveChatId: function getDefaultLiveChatId() {
                return this.Gon.live_feed_channels.honeybook_questions.id;
            },

            getLiveChats: function getLiveChats() {
                return this.Gon.live_feed_channels;
            },

            openConversation: function openConversation(conversationId){

                this.trigger('openConversation', conversationId);
                this.openConversationId = conversationId;
            },

            closeConversation: function closeConversation(conversationId){

                this.trigger('closeConversation', conversationId);
                this.openConversationId = null;
            },

            chatOpened: function chatOpened(conversationId){
                this.trigger('chatOpened', conversationId);
            },

            updateDirectMessagingConversationId: function updateDirectMessagingConversationId(conversationId){
                this.trigger('updateDirectMessagingConversationId', conversationId);
            },

            updateCommunityFeedConversationId: function updateCommunityFeedConversationId(conversationId){
                this.trigger('updateCommunityFeedConversationId', conversationId);
            },

            unsetOpenConversation: function unsetOpenConversation(){
                this.openConversationId = null;
            },

            startConversationTwoUsers: function startConversationTwoUsers(initiator, otherVendor){
                var usersIds = [];
                usersIds.push(initiator._id);
                usersIds.push(otherVendor._id);

                this.startConversation(usersIds);
            },

            startConversation: function startConversation(userIds){
                this.ConversationsManager.getOrCreateConversation(userIds).then(function sucsess(res) {

                    this.openConversation(res.data._id);
                    this.openConversationId = res.data._id;

                }.bind(this));
            },

            isConversationOpen: function isConversationOpen(conversationId){
              if (this.openConversationId == conversationId){
                  return true;
              }else{
                  return false;
              }
            },

            newMessageAddedToConversation: function newMessageAddedToConversation(conversationId){
                this.trigger('new_message_added', conversationId);
            }

        };
    });
}());
